// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-HoNzb7{align-items:center;margin-bottom:16px;display:flex}.wrapper-HoNzb7 .box-uNGhdX{background:#fff;border-radius:16px;padding:16px 20px;font-weight:500;box-shadow:0 32px 50px -12px rgba(10,17,61,.06),0 0 0 1px rgba(10,17,61,.06)}.wrapper-HoNzb7 .user-h4SEqb{background:linear-gradient(269deg,#a171ff -3.63%,#5d66ff 100.38%);font-weight:700}.wrapper-HoNzb7 .icon-sending-x2Or1n{color:#4d53e8;margin-left:10px}.wrapper-HoNzb7 .icon-fail-z0r_39{cursor:pointer;color:#ff441e;margin-left:10px}.wrapper-HoNzb7 .icon-fail-z0r_39>svg{width:16px;height:16px}.footer-slot-style-OuSiYh{gap:12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper-HoNzb7`,
	"box": `box-uNGhdX`,
	"user": `user-h4SEqb`,
	"icon-sending": `icon-sending-x2Or1n`,
	"iconSending": `icon-sending-x2Or1n`,
	"icon-fail": `icon-fail-z0r_39`,
	"iconFail": `icon-fail-z0r_39`,
	"footer-slot-style": `footer-slot-style-OuSiYh`,
	"footerSlotStyle": `footer-slot-style-OuSiYh`
};
export default ___CSS_LOADER_EXPORT___;
